import { ActionIcons } from '@vt/vt-ui';
import React, { memo } from 'react';
import { z } from 'zod';
import { SymbolInfoSchema } from '../../../types/symbol';

const SymbolItemPropsSchema = z.object({
  maxW: z.boolean().optional(),
  active: z.boolean(),
  keyIndex: z.number(),
  symbolInfo: SymbolInfoSchema,
  handleClick: z.function(),
  lastIndex: z.boolean()
});

export { SymbolItemPropsSchema };

const SymbolItem = memo(function SymbolItem(props) {
  const result = SymbolItemPropsSchema.safeParse(props);

  return (
    <div
      style={{
        transition: 'all 0.3s ease-in',
        filter: result.data?.maxW
          ? result.data.active
            ? ''
            : 'drop-shadow(-3mm 0mm 4mm rgb(25 23 23))'
          : ''
      }}
      className={`relative symbol-flex max-w-[150px] bg-[#151515] ${
        result.data.active ? 'active' : ''
      } ${
        result.data?.maxW
          ? 'animation-symbol-list hover:bg-[#151515] hover:-left-2 left-0'
          : 'animation-symbol-list-nomal'
      }`}>
      <div
        className="div-flex-center"
        onClick={() =>
          result.data?.handleClick('select', result.data?.keyIndex, result.data?.symbolInfo)
        }>
        <img
          className="rounded-[50%]"
          src={`https://storage.googleapis.com/iux-storage/symbol/${result.data?.symbolInfo.symbol}.png`}
          width="18px"
          height="18px"
          onError={({ currentTarget }) => {
            currentTarget.src = 'globe.svg';
          }}
        />
        <div className="symbol-name">{result.data?.symbolInfo.symbol}</div>
      </div>
      {!result.data?.lastIndex ? (
        <div
          className="close-symbol relative z-10 ml-2"
          onClick={() =>
            result.data?.handleClick('close', result.data?.keyIndex, result.data?.symbolInfo)
          }>
          <ActionIcons.Close className="stroke-[#9f9f9f] fill-[#9f9f9f] w-[12px] h-[12px]" />
        </div>
      ) : (
        <div />
      )}
    </div>
  );
});

export { SymbolItem };
